/**
 * Mapbox API URL.
 * @type {String}
 */
const MAPBOX_API_URL = 'https://api.mapbox.com';

/**
 * Shirt of marker longitude to align the marker to the arrow.
 * @type {Number}
 */
const SHIFT_MARKER_LNG = 0.00018;

/**
 * Static Maps API service.
 */
export default class StaticMapService {
    /**
     * Generate static map URL.
     * @param {String} lat Latitude of marker
     * @param {String} lng Longitude of marker
     * @param {String} width Width of image
     * @param {String} height Height of image
     * @param {Number} [zoom=15] Zoom of map
     * @param {Number} [scale=2] Scale of image (DPI for retina)
     * @return Static map URL
     */
    static getStaticMapUrl(lat, lng, width, height, zoom = 15, scale = 2) {
        const overlay = `url-${encodeURIComponent(
            MA.Config.STATIC_MAP_MARKER_URL,
        )}(${encodeURIComponent(lng)},${encodeURIComponent(lat + SHIFT_MARKER_LNG)})`;

        return `${MAPBOX_API_URL}/styles/v1/${
            MA.Config.MAPBOX_STATIC_STYLE
        }/static/${overlay}/${encodeURIComponent(lng)},${encodeURIComponent(
            lat,
        )},${encodeURIComponent(zoom)}/${encodeURIComponent(width)}x${encodeURIComponent(height)}${
            scale === 2 ? '@2x' : ''
        }?access_token=${MA.Config.MAPBOX_ACCESS_TOKEN}&attribution=false&logo=false`;
    }
}
